/**
 * Browser extensions often wrap window.fetch and then fail Stripe (and other)
 * cross-origin requests. CRA's overlay treats those as app crashes.
 */

function errorText(reason, event) {
  const message = reason?.message || event?.message || (typeof reason === 'string' ? reason : '');
  const stack = reason?.stack || event?.error?.stack || '';
  const filename = event?.filename || event?.error?.filename || event?.error?.fileName || '';
  return `${message}\n${stack}\n${filename}`;
}

export function isBrowserExtensionNoise(reason, event) {
  const text = errorText(reason, event);
  const filename = event?.filename || event?.error?.filename || event?.error?.fileName || '';
  const message = reason?.message || event?.message || (typeof reason === 'string' ? reason : '');

  if (
    text.includes('chrome-extension://') ||
    text.includes('moz-extension://') ||
    text.includes('safari-web-extension://') ||
    String(filename).startsWith('chrome-extension://') ||
    String(filename).startsWith('moz-extension://') ||
    String(filename).startsWith('safari-web-extension://')
  ) {
    return true;
  }

  return /reading ['"]M_ID['"]/.test(message);
}

export function isExtensionInterceptedFetchError(reason, event) {
  if (isBrowserExtensionNoise(reason, event)) return true;

  const text = errorText(reason, event);
  const message = reason?.message || (typeof reason === 'string' ? reason : '');

  return (
    message === 'Failed to fetch' &&
    (text.includes('js.stripe.com') ||
      text.includes('m.stripe.network') ||
      text.includes('injectScriptAdjust'))
  );
}
